module.exports = __webpack_public_path__ + "img/bg.0474cd66.jpg";